export default {
  apiHost: process.env.REACT_APP_API_HOST || "http://localhost:3000",
  clientId: process.env.REACT_APP_CLIENT_ID || "clientID",
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || "clientSecret",

  sentryUrl: process.env.REACT_APP_SENTRY_URL || ""
};



// WEBPACK FOOTER //
// ./src/config.js